import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Purpose from "@/pages/Purpose";
import Brands from "@/pages/Brands";
import BrandDetail from "@/pages/BrandDetail";
import Leadership from "@/pages/Leadership";
import LeaderProfile from "@/pages/LeaderProfile";
import Journey from "@/pages/Journey";
import Innovation from "@/pages/Innovation";
import Impact from "@/pages/Impact";
import Careers from "@/pages/Careers";
import Team from "@/pages/Team";
import TeamProfile from "@/pages/TeamProfile";
import JobDetail from "@/pages/JobDetail";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Media from "@/pages/Media";
import Partnerships from "@/pages/Partnerships";
import Contact from "@/pages/Contact";
import CorporateInfo from "@/pages/CorporateInfo";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminApp from "@/admin/AdminApp";
import PortalApp from "@/portal/PortalApp";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <Routes>
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/portal/*" element={<PortalApp />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/purpose" element={<Purpose />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/brands/:slug" element={<BrandDetail />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/leadership/:slug" element={<LeaderProfile />} />
          <Route path="/journey" element={<Journey />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/impact" element={<Impact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/team" element={<Team />} />
          <Route path="/team/:slug" element={<TeamProfile />} />
          <Route path="/careers/:slug" element={<JobDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
          <Route path="/media" element={<Media />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/corporate-information" element={<CorporateInfo />} />
          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/cookies" element={<Legal page="cookies" />} />
          <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
